import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

/**
 * Bitácora de acciones administrativas.
 *
 * Hasta ahora no quedaba rastro de quién editaba o borraba un registro: si un
 * negocio desaparecía, no había forma de saber quién lo hizo.
 *
 * Registrar nunca debe interrumpir la operación: si la escritura falla, se
 * avisa por consola y la acción principal sigue su curso.
 */

const COLECCION = "bitacora";

export const ACCIONES = {
  CREAR: "crear",
  EDITAR: "editar",
  ELIMINAR: "eliminar",
  ACTIVAR: "activar",
  DESACTIVAR: "desactivar",
};

export async function registrar({ accion, coleccion, docId, antes, despues, descripcion }) {
  try {
    const usuario = firebase.auth().currentUser;
    await firebase.firestore().collection(COLECCION).add({
      accion,
      coleccion,
      doc_id: docId || null,
      descripcion: descripcion || null,
      antes: limpiar(antes),
      despues: limpiar(despues),
      actor: usuario && usuario.email ? usuario.email : "desconocido",
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });
  } catch (err) {
    console.warn("[bitacora] no se pudo registrar la acción:", err);
  }
}

/**
 * Firestore rechaza `undefined` y no acepta anidamientos arbitrarios sin
 * revisar. Se guarda una copia plana y serializable del documento.
 */
function limpiar(obj) {
  if (!obj || typeof obj !== "object") return null;
  const salida = {};
  for (const clave of Object.keys(obj)) {
    const valor = obj[clave];
    if (valor === undefined || typeof valor === "function") continue;
    if (valor === null || ["string", "number", "boolean"].includes(typeof valor)) {
      salida[clave] = valor;
    } else if (Array.isArray(valor)) {
      salida[clave] = valor.filter((v) => ["string", "number", "boolean"].includes(typeof v));
    } else if (typeof valor.toDate === "function") {
      salida[clave] = valor;
    } else {
      salida[clave] = JSON.stringify(valor).slice(0, 500);
    }
  }
  return salida;
}

/** Últimos movimientos, del más reciente al más antiguo. */
export async function leerBitacora(limite = 200) {
  const snap = await firebase
    .firestore()
    .collection(COLECCION)
    .orderBy("timestamp", "desc")
    .limit(limite)
    .get();
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
